/**
 * Shown on every page of an "Open as company" tab: whose company this is,
 * who opened it, when it ends, and an Exit that ends the session server-side.
 */
import { useEffect, useState } from "react";
import instance from "../../api/instance";
import { clearOpenAsSession, getOpenAsSession } from "../../utils/openAsCompany";
import "./OpenAsBanner.css";

const fmtTime = (iso) => {
  const d = new Date(iso);
  return Number.isNaN(d.getTime())
    ? ""
    : d.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
};

export default function OpenAsBanner() {
  const [session, setSession] = useState(() => getOpenAsSession());
  const [ending, setEnding] = useState(false);

  // Past its end time the backend refuses the token anyway; say so here too.
  useEffect(() => {
    if (!session?.expires_at) return undefined;
    const ms = new Date(session.expires_at).getTime() - Date.now();
    const t = setTimeout(
      () => setSession((s) => (s ? { ...s, expired: true } : s)),
      Math.max(0, ms),
    );
    return () => clearTimeout(t);
  }, [session?.expires_at]);

  if (!session) return null;

  const exit = async () => {
    setEnding(true);
    try {
      await instance.post("job_scraper/open-as/");
    } catch {
      // Already ended or expired: nothing left to revoke.
    }
    clearOpenAsSession();
    try {
      window.sessionStorage.clear();
    } catch {
      // nothing to clear
    }
    window.location.replace("/login");
  };

  return (
    <div className="open-as-banner" role="status">
      <strong>Viewing as {session.company_name}</strong>
      <span>
        {session.expired
          ? "This session has ended. Exit and open the company again from the admin portal."
          : `Opened by ${session.opened_by} from the admin portal. Every change is recorded under that name. Ends at ${fmtTime(session.expires_at)}. Emails sent from here reach real people.`}
      </span>
      <button type="button" onClick={exit} disabled={ending}>
        {ending ? "Exiting…" : "Exit"}
      </button>
    </div>
  );
}
